import { request } from 'sonata-react-components';

type BidStreamCartographicFilter = {
  level: string;
  values: string[];
};

export type BidStreamFilters = {
  cartographic: BidStreamCartographicFilter[];
  audience: {
    gender?: string[];
    age?: string[];
    carrier?: string[];
    domain?: string[];
    deviceMake?: string[];
    deviceModel?: string[];
    deviceType?: string[];
    deviceLanguage?: string[];
    iabCategories?: string[];
  };
};

export type BidStreamResponse = {
  deviceIdsCount: number;
} | null;

export function getBidStream(
  country: string,
  filters: { cartographic?: BidStreamFilters['cartographic']; audience?: BidStreamFilters['audience'] },
  token: Record<string, any>
): Promise<BidStreamResponse> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}bidStream/audience`,
    {
      data: filters,
      method: 'POST',
      params: {
        country
      }
    },
    token
  );
}
